import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
export function FAQ() {
  const [openItem, setOpenItem] = useState(0);
  const faqs = [{
    question: 'How quickly will I see results after implementing the techniques?',
    answer: 'Many readers report feeling mental shifts within days of implementing the core techniques. The full benefits of the mindset reset typically become noticeable within 2-3 weeks of consistent practice.'
  }, {
    question: 'Is this guide suitable for all age groups?',
    answer: 'Absolutely! While the guide is particularly beneficial for those feeling mental fatigue or age-related decline in vitality, the principles work for anyone seeking greater mental clarity and energy, regardless of age.'
  }, {
    question: "I've tried other self-help books before with little success. How is this different?",
    answer: "Unlike generic self-help books, 'Young Mind' focuses specifically on practical mental reset techniques backed by neuroscience. The guide is concise (just 21 pages) with no fluff—only actionable strategies you can implement immediately."
  }, {
    question: "Is there a money-back guarantee if I'm not satisfied?",
    answer: "Yes! We offer a 30-day satisfaction guarantee. If you don't feel the guide has helped improve your mental clarity and vitality after implementing the techniques, simply reach out for a full refund."
  }, {
    question: 'How do I receive the ebook after purchase?',
    answer: "Immediately after your purchase, you'll receive an email with a download link for your PDF copy of 'Young Mind.' You can read it on any device that supports PDF viewing."
  }];
  return <section className="py-16 bg-gray-50" data-id="element-171">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-12" data-id="element-173">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-174">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-xl text-gray-600" data-id="element-175">
            Everything you need to know about the "Young Mind" guide.
          </p>
        </div>
        <div className="space-y-4" data-id="element-176">
          {faqs.map((faq, index) => <div key={index} className="bg-white rounded-lg shadow-sm overflow-hidden" data-id="element-177">
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenItem(openItem === index ? -1 : index)} data-id="element-178">
                <span className="text-lg font-medium text-gray-900" data-id="element-179">
                  {faq.question}
                </span>
                {openItem === index ? <ChevronUpIcon className="h-5 w-5 text-blue-600" data-id="element-180" /> : <ChevronDownIcon className="h-5 w-5 text-blue-600" data-id="element-181" />}
              </button>
              {openItem === index && <div className="px-6 pb-4" data-id="element-182">
                  <p className="text-gray-700" data-id="element-183">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="mt-10 text-center" data-id="element-184">
          <p className="text-gray-600 mb-4" data-id="element-185">
            Still have questions? Contact our support team at
            support@youngmindebook.com
          </p>
        </div>
      </div>
    </section>;
}